// Need to assign these functions to the window object or export them in order for them to be added
// to the main child-theme.js file
window.increaseCount = function (a, b) {

    var input = b.previousElementSibling;
    var value = parseInt(input.value, 10);
    value = isNaN(value) ? 0 : value;
    value++;
    input.value = value;

    
    document.dispatchEvent(
        new CustomEvent("increaseCount", {
            detail: {input: input, value: value},
        }),
    );

    window.toggleUpdateCartBtn;
};

window.decreaseCount = function (a, b) {

    var input = b.nextElementSibling;
    var value = parseInt(input.value, 10);
    var min = input.min ? parseInt(input.min, 10) : 1;
    if (value > min) {
        value = isNaN(value) ? 0 : value;
        value--;
        input.value = value;
    }

    document.dispatchEvent(
        new CustomEvent("decreaseCount", {
            detail: {input: input, value: value},
        }),
    );

    window.toggleUpdateCartBtn;
};

window.toggleUpdateCartBtn = function () {
    var el = document.querySelector("button[name='update_cart']");

    if (el) {
        el.disabled = false;
    }
};

window.serializeObject = function (form) {
    // Create a new FormData object
    const formData = new FormData(form);

    // Create an object to hold the name/value pairs
    const pairs = {};

    // Add each name/value pair to the object
    for (const [name, value] of formData) {
        pairs[name] = value;
    }

    // Return the object
    return pairs;
};
